import React from "react";

const Divider = () => (
    <div
        style={{
            width: "100%",
            height: "1px",
            backgroundColor: "#e1eaf0",
        }}
    />
);

export default Divider;
